<script setup lang="ts">
const { state, close } = useDialog()
</script>

<template>
  <div v-if="state.isVisible" class="layer active">
    <div class="mask"></div>
    <div class="inner">
      <section class="alert">
        <main>
          <h3 v-if="state.title">{{ state.title }}</h3>
          <p v-dompurify-html="state.message"></p>
        </main>
        <footer>
          <div class="btnArea">
            <a
              class=""
              @click="
                () => {
                  close()
                  state.onCancel?.()
                }
              "
              >{{ state.cancelText }}</a
            >
            <a
              class="active"
              @click="
                () => {
                  close()
                  state.onOk?.()
                }
              "
              >{{ state.okText }}</a
            >
          </div>
        </footer>
      </section>
    </div>
  </div>
</template>

<style scoped></style>
